import {Button, Stack} from '@mui/material';
import React from 'react';
import {useNavigate} from 'react-router-dom';

import {useMediaQueries} from 'presentation/pages/private/hooks';
import {ConfirmToGoButton} from 'presentation/modules/myAppointments/ui/components/ConfirmToGoButton';
import {MY_APPOINTMENT_DETAILS_PATH} from 'presentation/modules/myAppointments/constants/appointmentDetailsPath';
import {translations} from 'presentation/translations-new';
import {PrefixTestEnum} from 'presentation/constants/PrefixTestEnum';
import {CardFooterProps} from './types';
import {useVoiceTranscriptionDrawerStore} from 'presentation/components/VoiceTranscriptionDrawer/store';
import {FeaturesEnum, TermsOriginEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';

const {appointmentCard} = translations['pt-br'].privateFlow.myAppointments;

export function CardFooter({appointment, showEnterRoom}: CardFooterProps) {
	const navigate = useNavigate();
	const {isMobile} = useMediaQueries();
	const onOpen = useVoiceTranscriptionDrawerStore(state => state.onOpen);
	const {isEnabled: isUrgencyTeleTermsEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_URGENCY_TELE_TERMS,
	);

	function handleGoToDetails() {
		navigate(
			MY_APPOINTMENT_DETAILS_PATH[appointment.bookingType].replace(
				':id',
				appointment.bookingNumber,
			),
		);
	}

	function handleOpenTelehealthRoom() {
		if (appointment.telehealthUrl) {
			if (isUrgencyTeleTermsEnabled) {
				onOpen(appointment.telehealthUrl, TermsOriginEnum.TELEHEALTH);
				return;
			}

			window.open(appointment.telehealthUrl);
		}
	}

	return (
		<Stack direction="row" alignItems="center" justifyContent="space-between">
			{showEnterRoom ? (
				<Button size="large" onClick={handleOpenTelehealthRoom}>
					{appointmentCard.teleHealth.goToTelehealthRoom}
				</Button>
			) : (
				<ConfirmToGoButton appointment={appointment} />
			)}
			<Button
				variant="text"
				size={isMobile ? 'small' : 'medium'}
				onClick={handleGoToDetails}
				sx={{
					marginLeft: 'auto',
				}}
				data-testid={`${PrefixTestEnum.SEE_DETAILS}${appointment.bookingType}`}>
				{appointmentCard.goToDetails}
			</Button>
		</Stack>
	);
}
